import React from "react";
import { AccountingDashboardPage } from "./pages/dashboard/accounting.dashboard";
import { ChartOfAccountsPage } from "./pages/chartOfAccounts/chart.of.accounts";
import { JournalsPage } from "./pages/journals/journals";
import { VouchersPage } from "./pages/vouchers/vouchers";
import { VoucherTemplatesPage } from "./pages/vouchers/voucher.templates";
import { LedgerPage } from "./pages/ledger/ledger";
import { ReportsPage } from "./pages/reports/reports";
import { ActivitiesPage } from "./pages/activities/activities";
import { SettingsPage } from "./pages/settings/settings";
import { ConfigurationDashboard } from "./pages/configuration/dashboard";
import { COAMappingsConfig } from "./pages/configuration/components/COAMappingsConfig";
import { VoucherSettingsConfig } from "./pages/configuration/components/VoucherSettingsConfig";
import { JournalSettingsConfig } from "./pages/configuration/components/JournalSettingsConfig";
import { LedgerSettingsConfig } from "./pages/configuration/components/LedgerSettingsConfig";
import { PermissionsOverview } from "./pages/configuration/components/PermissionsOverview";
import { RouteObject } from "react-router-dom";
import { Outlet } from "react-router-dom";
import { Navigate } from "react-router-dom";
import { AccountingLayout } from "./accounting.index";
import { BusinessAdminGuard } from "../business-admin/components/BusinessAdminGuard/BusinessAdminGuard";
import { AuthProvider } from "../auth/AuthProvider";

export const accountingRoutes: RouteObject[] = [
  {
    path: "accounting",
    element: (
      <AuthProvider>
        <BusinessAdminGuard>
          <AccountingLayout>
            <Outlet />
          </AccountingLayout>
        </BusinessAdminGuard>
      </AuthProvider>
    ),
    children: [
      {
        path: "",
        element: <Navigate to="dashboard" replace />,
      },
      {
        path: "dashboard",
        element: <AccountingDashboardPage />,
      },
      {
        path: "chart-of-accounts",
        element: <ChartOfAccountsPage />,
      },
      {
        path: "journals",
        element: <JournalsPage />,
      },
      {
        path: "vouchers",
        element: <VouchersPage />,
      },
      {
        path: "vouchers/templates",
        element: <VoucherTemplatesPage />,
      },
      {
        path: "ledger",
        element: <LedgerPage />,
      },
      {
        path: "reports",
        element: <ReportsPage />,
      },
      {
        path: "activities",
        element: <ActivitiesPage />,
      },
      {
        path: "settings",
        element: <SettingsPage />,
      },
      {
        path: "configuration",
        element: <ConfigurationDashboard />,
      },
      {
        path: "configuration/coa-mappings",
        element: <COAMappingsConfig />,
      },
      {
        path: "configuration/voucher-settings",
        element: <VoucherSettingsConfig />,
      },
      {
        path: "configuration/journal-settings",
        element: <JournalSettingsConfig />,
      },
      {
        path: "configuration/ledger-settings",
        element: <LedgerSettingsConfig />,
      },
      {
        path: "configuration/permissions",
        element: <PermissionsOverview />,
      },
    ],
  },
];
